import React, { ReactNode } from "react";
import { getAuthToken } from "../../commonGlobals/functions/localStorage/getUser";
import { useAppSelector } from "../../store";

export const ProtectedRoute: React.FC<{
  children: ReactNode;
}> = (props) => {
  const token = getAuthToken();
  const { moduleUrls } = useAppSelector((state) => state.siteData);

  if (!token) {
    // navigate to /login--->
    const loginUrl = moduleUrls?.login || "/app/login";
    const redirectTo = window.location.pathname + window.location.search;
    window.location.href =
      loginUrl + "?redirectTo=" + redirectTo + "&redirectType=external";
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};
